const locations = {
  toast: {
    error: {
      badResponse: '[Ubicación] respuesta incorrecta del servidor',
      create: {},
      edit: {},
    },
    success: {
      create: {
        default: '[Ubicación] se creó correctamente',
      },
      edit: {},
      delete: {
        default: '[Ubicación] se eliminó correctamente',
      },
    },
  },
  headerButtons: {
    create: {
      createBtn: 'Crear',
    },

    import: 'Importar',
  },

  deleteModal: {
    header: 'Eliminar ubicaciones',
    body: 'Está a punto de eliminar {{num}} ubicaciones.',
  },

  printoutsModal: {
    title: 'Exportación de PDF de impresiones',
    description: 'Seleccione un rango de fechas (máximo 31 días)',
    maxRangeError: 'Seleccione un rango de 31 días o menos',
    export: 'Exportar',
  },

  table: {
    filters: {
      type: 'Tipo',
    },
    actions: {
      delete: 'Eliminar',
      export: 'Exportar',
      printouts: 'Impresiones',
    },
    moreActions: {
      showOnMap: 'Mostrar en el mapa',
    },
    headers: {
      name: 'Nombre',
      type: 'Tipo',
      address: 'Dirección',
      lat: 'Latitud',
      lon: 'Longitud',
      locationTypes: {
        location: 'Localización',
        inAndOut: 'Dentro y fuera',
        airport: 'El aeropuerto',
        facility: 'Instalación',
      },
      wait: 'Espera',
    },
    toolTip: {
      noPermission: 'Action not allowed: Permission required',
    },
  },
  form: {
    header: {
      createLocation: {
        title: 'Crear',
      },

      updateLocation: {
        title: 'Actualizar',
      },
    },

    footer: {
      confirmButtonText: {
        create: 'Enviar',
        update: 'Enviar',
      },
    },

    addressInformation: {
      title: 'Información de dirección',
      name: 'Nombre',
      type: 'Tipo',
      wait: 'Espera',
      address: 'Dirección',
      locationTypes: {
        location: 'Localización',
        inAndOut: 'Dentro y fuera',
        airport: 'El aeropuerto',
        facility: 'Instalación',
      },
    },
    radius: {
      title: 'Radio de Coincidencia de Dirección',
      toolTipInformation:
        'El radio en metros o pies (m/ft para métrico/imperial) dentro del cual las reservas se reconocen como la ubicación y/o como espera y regreso.',
    },
    waitAndReturn: {
      title: 'Espera y vuelve',
      time: 'Tiempo de espera',
      timeDescription:
        'La duración en minutos que un conductor esperará entre los tramos de salida y de vuelta de un viaje de espera y vuelta.',
    },
    advancedSettings: {
      consistentPassengerRouting: {
        title: 'Enrutamiento Consistente de Pasajeros',
        toolTipInformation:
          'Asegura que el mismo grupo de pasajeros siempre siga la misma ruta de ida y vuelta a la instalación, optimizando la eficiencia del viaje y minimizando la confusión.',
      },
      snapAddressWithinRadius: {
        title: 'Ajustar Dirección Dentro del Radio',
        toolTipInformation:
          'Cuando un punto de recogida/entrega está dentro del radio de la ubicación, se ajusta al nombre y las coordenadas de la ubicación',
      },
      sameDriverForGroup: {
        title: 'Mismo Conductor para el Grupo',
        toolTipInformation:
          'Asigna el mismo conductor para transportar al grupo de pasajeros tanto en la recogida como en la entrega, proporcionando familiaridad y consistencia.',
      },
      overrideOptions: {
        bySystemSettings: 'Según la Configuración del Sistema',
        enabled: 'Habilitado',
        disabled: 'Deshabilitado',
      },
      allowSharedRide: {
        title: 'Permitir Viaje Compartido con Otras Direcciones',
        toolTipInformation:
          'Cuando está habilitado, esta configuración permite que los viajes compartidos se agrupen con reservas de otras ubicaciones que tengan rutas consistentes. Si está deshabilitado, solo se considerarán viajes de la misma ubicación para el agrupamiento.',
      },
      waitForBoardingTime: {
        title: 'Esperar tiempo de abordaje',
        toolTipInformation: 'Al llegar a una parada, el conductor esperará hasta el tiempo exacto de recogida, si es necesario.',
      },
      tripBoardingTime: {
        title: 'Tiempo de abordaje',
        toolTipInformation:
          'El tiempo que lleva recoger a un pasajero en su parada (este parámetro impactará en la duración total del viaje).',
      },
      tripDropOffTime: {
        title: 'Tiempo de entrega',
        toolTipInformation:
          'El tiempo que lleva dejar a un pasajero en su parada (este parámetro impactará en la duración total del viaje).',
      },
      pickupTimeBuffer: {
        title: 'Pickup Time Buffer',
        toolTipInformation: 'Adjusts the reservation pickup time by a configurable number of minutes when this location matches the booking.',
        directionTitle: 'Buffer Direction',
        directionToolTipInformation: 'Choose whether this pickup-time buffer applies when the reservation matches this location as the origin, destination, or either side.',
        directionOptions: {
          to: 'To',
          from: 'From',
          both: 'Both',
        },
      },
      maxDropOffEarly: {
        title: 'Máx. Anticipación de Descenso',
        toolTipInformation:
          'Número máximo de minutos que un conductor puede llegar antes en relación con la hora de descenso establecida en la reservación',
      },
      maxDropOffDelay: {
        title: 'Máx. Retraso de Descenso',
        toolTipInformation:
          'Número máximo de minutos que un conductor puede retrasarse en relación con la hora de descenso establecida en la reservación',
      },
      maxBoardingDelay: {
        title: 'Máx. Retraso de Abordaje',
        toolTipInformation:
          'Número máximo de minutos que un conductor puede retrasarse en relación con la hora de recogida establecida en la reservación',
      },
      maxBoardingEarly: {
        title: 'Máx. Anticipación de Abordaje',
        toolTipInformation:
          'Número máximo de minutos que un conductor puede llegar antes en relación con la hora de recogida establecida en la reservación',
      },
      maxTripDuration: {
        title: 'Duración Máxima del Viaje',
        toolTipInformation: 'Duración máxima de un viaje en minutos',
      },
      maxSinglePassengerTime: {
        title: 'Tiempo Máximo de Viaje por Pasajero',
        toolTipInformation: 'Duración máxima de un viaje en minutos por pasajero',
      },
    },

    advanced: {
      title: 'Avanzado',
      addTime: {
        addTimeBtn: 'Añadir hora',
        name: 'Nombre',
        minutes: 'Minutos',
        enterMinutes: 'Introduzca los minutos',
        enterName: 'Introduzca el nombre',
      },
    },
    map: {
      title: 'Mapa',
    },
    site: {
      title: 'Sitio',
    },

    info: {
      subLocations: {
        addSubLocationBtn: 'Añadir terminal',
        header: 'Terminal',
        fields: {
          subLocation: 'Dirección',
          name: {
            label: 'Nombre de la dirección',
            placeholder: 'Nombre',
          },
        },
      },
    },
  },

  update: {
    confirmButtonText: 'Actualizar',
    formTabs: {
      info: 'Información',
      history: 'Historia',
      advancedSettings: 'Configuraciones Avanzadas',
    },

    successToast: {
      message: 'Creado! Ubicación actualizada correctamente.',
    },

    errorToast: {
      message: 'Error. No se pudo actualizar la ubicación.',
    },
  },

  create: {
    formTabs: {
      info: 'Información',
      advancedSettings: 'Configuraciones Avanzadas',
    },
    successToast: {
      message: 'Creado! Ubicación creada correctamente.',
    },

    errorToast: {
      message: 'Error. No se pudo crear la ubicación.',
    },
  },

  delete: {
    successToast: {
      message: '¡Eliminado! Ubicación eliminada correctamente.',
    },

    errorToast: {
      message: 'Error. No se pudo eliminar la ubicación.',
    },
  },

  createModal: {
    title: 'Esperar y regresar',
    body: "Estás a punto de designar esta ubicación como una ubicación de 'Esperar y regresar'. Esto aplicará automáticamente la configuración de 'Esperar y regresar' a todas las reservaciones futuras en esta ubicación. ¿Estás seguro de que deseas continuar?",
  },
  enableLocationTypeModal: {
    title: 'Esperar y regresar',
    body: "Estás a punto de habilitar la configuración de 'Esperar y regresar'. Esto se aplicará a todas las reservaciones actuales y futuras que califiquen como 'Esperar y regresar'. ¿Estás seguro de que deseas continuar?",
  },
  disableLocationTypeModal: {
    title: 'Esperar y regresar',
    body: "Estás a punto de deshabilitar la configuración de 'Esperar y regresar'. Esto la eliminará de todas las reservaciones actuales y futuras identificadas como 'Esperar y regresar'. ¿Estás seguro de que deseas continuar?",
  },
  deleteLocationTypeModal: {
    title: 'Estás a punto de eliminar {{count}} ubicaciones.',
    titleAll: 'Estás a punto de eliminar todas las ubicaciones.',
    body: "Estás a punto de eliminar esta ubicación como una ubicación de 'Esperar y regresar'. Esto aplicará automáticamente la configuración de 'Esperar y regresar' a todas las reservaciones futuras en esta ubicación. ¿Estás seguro de que deseas continuar?",
  },
  updateLocationOfTypeLocationModal: {
    title: 'Esperar y regresar',
    body: "Estás a punto de cambiar esta ubicación a una ubicación de 'Esperar y regresar'. Esto aplicará automáticamente la configuración de 'Esperar y regresar' a todas las reservaciones futuras en esta ubicación. ¿Estás seguro de que deseas continuar?",
  },
};

export default locations;
